export function isSignupReportRequestSuccessful(response) {
  const status = response?.status
  if (typeof status === 'number') return status < 400
  return !response?.error
}

export async function requestSignupReport({ email, send, t }) {
  if (!email) {
    window.alert(
      t(
        'VolunteerListScreen.downloadAlertErrorNoEmail',
        'This report will be delivered to your account email. If email is not available enter one in your Account Settings.',
      ),
    )
    return false
  }

  const confirmed = window.confirm(
    t(
      'VolunteerListScreen.downloadAlertMessage',
      'This report will be delivered to your account email "{{email}}".',
      { email },
    ),
  )
  if (!confirmed) return false

  const response = await send()
  if (!isSignupReportRequestSuccessful(response)) {
    throw (
      response?.error ||
      new Error(response?.data?.error || 'Cannot email report.')
    )
  }

  window.alert(
    t(
      'VolunteerListScreen.downloadAlertSuccess',
      'The Sign Up Report will be delivered to your account email.',
    ),
  )
  return true
}
